/* eslint-disable one-var,one-var-declaration-per-line */

import PropTypes from 'prop-types';
import React, {Component} from 'react';

import MediaElement, {MediaTypes} from '../../../components/MediaElement';


/**
 * Renders a media block component.
 */
class Media extends Component {

    static canContinue(answer) {
        return !Boolean(answer);
    }

    static rounded(value) {
        return parseFloat(value.toFixed(2));
    }

    constructor(props) {
        super(props);

        this.mediaEventHandlers = {
            onPause: this.onPause,
            onTimeUpdate: this.onTimeUpdate,
            onLoadedMetadata: this.onLoadedMetadata,
        };
    }

    render() {
        const {seekable, config, onContinue} = this.props;
        const {type, name, url} = config;
        const eventHandlers = type === 'image' ? {} : this.mediaEventHandlers;
        const autoplay = config.autoplay || false;

        return (
            <div className="media-block">
                <MediaElement
                    type={type}
                    {...eventHandlers}
                    url={url}
                    name={name}
                    seekable={seekable}
                    controls={!autoplay}
                    autoPlay={autoplay}
                    onFinish={autoplay ? onContinue : null}
                />
            </div>
        );
    }

    componentDidMount() {
        const {config: {type, id}, updateAnswer} = this.props;
        let played = 0, playedPercentage = 0;

        if (type === 'image') {
            played = 1;
            playedPercentage = 100;
        }

        updateAnswer({
            medium: id,
            stoppedAt: [],
            played,
            playedPercentage,
        });
    }

    onLoadedMetadata = event => {
        this.duration = event.currentTarget.duration;
    };

    onTimeUpdate = event => {
        const {answer = {}} = this.props;
        const currentTime = event.currentTarget.currentTime;

        this.props.updateAnswer({
            ...answer,
            played: Media.rounded(currentTime),
            playedPercentage: Media.rounded(Math.min(currentTime / this.duration, 100)),
        });
    };

    onPause = event => {
        const {stoppedAt = []} = this.props.answer || {};
        const currentTime = Media.rounded(event.currentTarget.currentTime);

        this.props.updateAnswer({
            stoppedAt: [...stoppedAt, Media.rounded(currentTime)],
            played: Media.rounded(currentTime),
            playedPercentage: Media.rounded(Math.min(currentTime / this.duration, 100)),
        });
    };

}

Media.propTypes = {
    seekable: PropTypes.bool,
    config: PropTypes.shape({
        type: PropTypes.oneOf(
            Object.keys(MediaTypes),
        ),
        url: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                low: PropTypes.string,
                high: PropTypes.string,
            }),
        ]).isRequired,
        autoplay: PropTypes.bool,
    }).isRequired,
    answer: PropTypes.shape({
        stoppedAt: PropTypes.arrayOf(PropTypes.number),
        playedPercentage: PropTypes.number,
    }).isRequired,
    updateAnswer: PropTypes.func.isRequired,
};

Media.defaultProps = {
    seekable: true,
};

export default Media;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/Media.js